import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Action types & creators
 */
const { Types, Creators } = createActions({
  resetDashboard: [],
  loadDashboard: ['partner', 'params'],
  loadDashboardSuccess: ['data']
});

export { Types };

export default Creators;

/**
 * Handlers
 */
const INITIAL_STATE = Immutable({
  loading: true,
  data: {
    indicators: {
      charge_sum: 0,
      charge_min: 0,
      charge_max: 0,
      charge_count: 0,
      average: 0
    },
    charts: {
      charges: {
        transactions: [
          { status: 'declined', charge_count: 0, charge_sum: 0 },
          { status: 'cancelled', charge_count: 0, charge_sum: 0 },
          { status: 'chargeback', charge_count: 0, charge_sum: 0 },
          { status: 'not_cleared', charge_count: 0, charge_sum: 0 },
          { status: 'pre_approved', charge_count: 0, charge_sum: 0 }
        ],
        reasons_declined: [],
        installments: [],
        charges_month_volume: [],
        charges_month_quantity: [],
        brands: []
      }
    }
  }
});

const resetDashboard = () => INITIAL_STATE;

const loadDashboard = () => INITIAL_STATE;

const loadDashboardSuccess = (state, action) => ({
  ...state,
  loading: false,
  data: action.data
});

/**
 * Reducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.RESET_DASHBOARD]: resetDashboard,
  [Types.LOAD_DASHBOARD]: loadDashboard,
  [Types.LOAD_DASHBOARD_SUCCESS]: loadDashboardSuccess
});
